import { IRoleTypeDataService } from "../../core/jobroletypes.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { JobRoleTypes } from "./jobroletypes.component";
import { EditJobRoleType } from "./jobroletype.edit.component";
import { JobRoleType } from "./jobroletype.component";

/**
 * This state displays all Job Role Types
 */
export const jobRoleTypesState: Ng2StateDeclaration = {
    name: "app.settings.jobroletypes",
    url: "/jobroletypes",
    views: {
        "main-view@app": {
            component: JobRoleTypes
        }
    },
    resolve: {
        jobRoleTypes: ["roleTypeDataService", (roleTypeDataService: IRoleTypeDataService) => {
            return roleTypeDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Job Role Type
 */
export const newJobRoleTypeState: Ng2StateDeclaration = {
    name: "app.settings.jobroletypes.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditJobRoleType
        }
    },
    resolve: {
        jobRoleType: function () {
            return <Nema.Crew.Model.RoleType>{ Id: -1, Name: "", Active: true, SortTag: "", CompetenceRequirementRoleTypes: null, CompetenceRequirements: null, JobTypes: null, PersonRoles: null, Description: "" };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Job Role Type
 */
export const editJobRoleTypeState: Ng2StateDeclaration = {
    name: "app.settings.jobroletypes.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditJobRoleType
        }
    },
    resolve: {
        jobRoleType: ["roleTypeDataService", "$stateParams", function (roleTypeDataService: IRoleTypeDataService, $stateParams) {
            return roleTypeDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Job Role Type Details state
 */
export const jobRoleTypeState: Ng2StateDeclaration = {
    name: "app.settings.jobroletypes.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: JobRoleType
        }
    },
    resolve: {
        jobRoleType: ["roleTypeDataService", "$stateParams", function (roleTypeDataService: IRoleTypeDataService, $stateParams) {
            return roleTypeDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobroletypes/jobroletypes.states.ts